import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-trip-detail',
  templateUrl: './trip-detail.component.html',
  styleUrls: ['./trip-detail.component.css']
})
export class TripDetailComponent implements OnInit {

  public cityList: any = [];

  constructor(public service: AmbitService,
    public route: ActivatedRoute,
    public router: Router) {
    if (this.service.adminUser.userAccess.trips == 'None') {
      this.router.navigate(['/home']);
    }
    this.getCitiesData();
    if (this.route.snapshot.params['id']) {
      service.tripId = this.route.snapshot.params['id'];
    }
  }

  ngOnInit() {
    var self = this;
    self.service.tripId = self.route.snapshot.params['id'];
    if (self.service.allTrips.length) {
      self.service.tripDetails = self.service.allTrips.find(ob => ob['tripID'] === self.service.tripId);
    } if (self.service.driversList.length) {
      self.service.tripDetails['driverInfo'] = self.service.driversList.find(ob => ob['uid'] === self.service.tripDetails.uid);
    } if (self.service.carList.length) {
      self.service.tripDetails['carInfo'] = self.service.carList.find(ob => ob['carId'] === self.service.tripDetails.vehicleId);
    } if (self.service.userAllBookings.length) {
      self.service.getTripEarnings();
    }
  }

  getCitiesData() {
    var self = this;
    firebase.database().ref().child('Cities')
      .once('value', function (snapshot) {
        self.cityList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].cityID = key;
            self.cityList.push(data[key]);
          }
        }
      });
  }

  getCityName(cityID) {
    var data = this.cityList.find(ob => ob['cityID'] === cityID);
    if (data) {
      return data.name;
    } else {
      return '';
    }
  }

}